import { render, staticRenderFns } from "./cajas.vue?vue&type=template&id=b698cdd4&scoped=true"
import script from "./cajas.vue?vue&type=script&lang=js"
export * from "./cajas.vue?vue&type=script&lang=js"
import style0 from "./cajas.vue?vue&type=style&index=0&id=b698cdd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b698cdd4",
  null
  
)

export default component.exports